import AuthService from "../AuthService";
import { fetchJSON } from "../../helpers/Helpers";

export default class MembersApi {

    static callId = 0;

    static search(query, sortField, sortOrder, allowCache, actualSearch = null, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: new Headers({
                'Authorization': 'Bearer ' + AuthService.getToken()
            })
        };
        if (allowCache) {
            options.headers.append('cache-control', 'max-age=300');
        }
        else {
            options.headers.append('pragma', 'no-cache');
            options.headers.append('cache-control', 'no-cache');
        }
        fetchJSON('/api/members?q=' + query + '&sort=' + sortField + '&dir=' + sortOrder + '&limit=20&actualSearch=' +actualSearch, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getMember(id, callback, isPolling) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const isPollParam = isPolling ? `?isPoll=1` : '';
        const url = `/api/members/${id}${isPollParam}`;
        fetchJSON(url, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getCountry(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/country';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }


    static getStores(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/stores';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getAllUsers(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/allUsers';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getQuestions(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/questions';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getMyQuestions(name='',callback){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/myquestions?username='+name;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getQA(callback){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/qa';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }


    static getUsers(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/users?id=' + id;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getUserQA(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/getUserQA?id=' + id;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    } 

    static getUserSecurityQuestions(callback, username) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/getUserSecurityQuestions?username=' + username;
        fetchJSON(url, options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }

    static fetchUsersInStore(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = `/api/globals/fetchUsersInStore/${id}`;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchOneUserInStore(callback, id, storeId) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = `/api/globals/fetchOneUserInStore/${id}/${storeId}`;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchFuturaCustomer(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = `/api/globals/fetchFuturaCustomer/${id}`;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchAllUsers(callback, byAdmins = null, page = null, search = null, byStore = null, byRole = null, sort=null) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        let url = '/api/globals/fetchAllUsers';

        if (byAdmins == 'byAdmins') {
            url += `?byAdmins=${byAdmins}`;
        } else if (byAdmins == 'areaManagers') {
            url += `?areaManagers=${byAdmins}&sort=${sort}`;
        } else { 
            // if (byAdmins == null && page != null) {
            //     url += `?page=${page}`;
            // } 
            url += `?page=${page}`;
            if(search != null) {
                url += `&search=${search}`;
            } 
            
            if(byStore != null) {
                url += `&byStore=${byStore}`;
            } 
            
            if(byRole != null) {
                url += `&byRole=${byRole}`;
            }

            if(sort != null) {
                url += `&sort=${sort}`;
            }
        }

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchUsersOfAM(callback, amId) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        let url = '/api/globals/fetchUsersOfAM/' + amId;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchOneUser(callback, id, amId = null) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = amId == null ? `/api/globals/fetchOneUser/${id}` : `/api/globals/fetchOneUser/${id}?amId=${amId}`;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }
    static fetchAllStores(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/fetchAllStores';

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchAllStoresInTabularFormat(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/fetchAllStoresInTabularFormat/' + id;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchStoresOfAM(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = `/api/globals/fetchStoresOfAM/${id}`;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static suggestNames(callback, userInput) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = `/api/globals/suggestNames?input=${userInput}`;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getPromotions(email, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        fetchJSON('/api/members/' + email + '/promotions', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static genPromotions(slug, promo = '', unsubs = false, wasSubscribed = false, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        fetchJSON('/api/globals/genCert?slug=' + slug + '&type=' + promo + '&shouldUnsub=' + (unsubs ? "Y" : "N") + "&wasSubscribed=" + wasSubscribed, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getUpdateHistory(callback, id, offset, field = '', token = '', offsetTz = '', timezone = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/updates?id=' + id + '&offset=' + offset;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getPurchaseHistory(callback, id, offset, field = '', token = '', offsetTz = '', timezone = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '';
        if ((field != '' || field != undefined) && (token != '' || token != undefined)) {
            url = '/api/globals/userPurchaseHistory?id=' + id + '&offset=' + offset + '&col=' + field + '&token=' + token + '&offset_tz=' + offsetTz + '&timezone=' + timezone + '&download=N';
        } else {
            url = '/api/globals/userPurchaseHistory?id=' + id + '&offset=' + offset + '&download=N';
        }

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static downloadAsCsv(id, offset = 0, field = '', token = '', offsetTz = '', timezone = '', callback) {

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken(),
                'Content-type': 'text/csv'
            }
        };
        let url = '';
        if ((field != '' || field != undefined) && (token != '' || token != undefined)) {
            url = '/api/globals/downloadPurchaseHistory?id=' + id + '&offset=' + offset + '&col=' + field + '&token=' + token + '&offset_tz=' + offsetTz + '&timezone=' + timezone + '&download=Y';
        } else {
            url = '/api/globals/downloadPurchaseHistory?id=' + id + '&offset=' + offset + '&download=Y';
        }

        fetch('/index.php' + url, options).then((res) => res.blob())
            .then((blob) => URL.createObjectURL(blob))
            .then((href) => {
                callback(href);
                Object.assign(document.createElement('a'), {
                    href,
                    download: 'transaction_history.csv',
                }).click();
            });
    }

    static getCardHistory(callback,card=''){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '/api/globals/userGiftCardHistory?crd='+card;
        
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getPurchaseHistoryItems(callback,id,offset,field='',token=''){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '/api/globals/userPurchaseHistoryItems?id=' + id + '&offset=' + offset + '&col=' + field + '&token=' + token;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getUserStats(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '/api/globals/userStats?id=' + id;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getStoreDetails(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/stdetails?id=' + id;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static fetchstoreDetailsAndStores(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/fetchstoreDetailsAndStores?id=' + id;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static delUser(callback, id, type, usid = null) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/deleteUser?id=' + id + '&type=' + type + '&usid=' + usid;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static delUserByAM(callback, id, type, amId) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/deleteUser?id=' + id + '&type=' + type + '&amId=' + amId;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static restartQ(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/restartQueue';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static delStoreAndUsers(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/deleteStore?id=' + id;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getSubscriptionStatus(email, callback) {
        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        fetchJSON('/api/members/' + email + '/subscription-status', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getIsEmailAvailable(email, callback) {
        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        fetchJSON('/api/members/' + email + '/is-email-available', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static isMobileNumberAvailable(mobile, callback) {
        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        fetchJSON('/api/members/isMobileNumberAvailable/' + mobile, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getStockLevel(callback) {
        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        fetchJSON('/api/members/digital-cards/stock-level', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static setSubscriptionStatus(slug, newStatus, callback) {
        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        formData.append('action', newStatus);
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members/' + slug + '/subscription-status', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static settingsSave(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/settingsave', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static setNews(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/setNews', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static deleteNews(id, callback) {
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };
        fetchJSON('/api/globals/deleteNews/'+id, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static markAsImportant(id, callback) {
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };

        const url = `/api/globals/markAsImportant/${id}`;
        
        fetchJSON(url, options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }

    static updateUserQA(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/updateUserQA', options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }

    static resetPassword(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/resetPassword', options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }    static settingsSyncDigitalCard(callback) {
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };
        fetchJSON('/api/members/digital-cards/syncBlankDigitalCards', options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }



    static setqa(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };

        fetchJSON('/api/globals/qasave', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static qaMatch(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };

        fetchJSON('/api/globals/qaMatch', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static resendPromotion(slug, promotionId, promotionKey, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        formData.append('id', promotionId);
        formData.append('promotion', promotionKey);
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members/' + slug + '/resend-promotion', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static lastCard(callback, jobId) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '/api/members/digital-cards/lastCard';
        if (jobId !== null && jobId !== '') {
            url += '/' + jobId;
        }
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getLastSyncDetails(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        fetchJSON('/api/members/digital-cards/getLastSyncDetails', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static resendCard(slug, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };
        fetchJSON('/api/members/' + slug + '/resend-card', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static saveComment(slug, comment, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        formData.append('comment', comment);

        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members/' + slug + '/comment', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static deleteComment(slug, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };
        fetchJSON('/api/members/' + slug + '/comment/delete', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static newMember(data, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static newStore(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/saveStore', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static apiStatsToGraph(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/apiStatsToGraph', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static jobsToGraph(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/jobsToGraph', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static addUser(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/addUser', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static setStoreAndRole(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/setStoreAndRole', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static searchUsers(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/searchUsers', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static multiAddUser(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/multiAddUser', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static updateStore(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/updateStore', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static updateUser(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/updateUser', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static updateMultiUser(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/updateMultiUser', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static getUserDetails(callback, id) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/userDetails?id=' + id;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getJobs(callback, category, id = '', offset = '', column = '', token = '', offsetTz = '', timezone = '', graphTime = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '';
        if (id != '' && id != undefined)
            url = '/api/globals/jobs?type=' + category + '&jid=' + id;
        else
            url = '/api/globals/jobs?type=' + category + '&offset=' + offset + '&column=' + column + '&token=' + token + '&offset_tz=' + offsetTz + '&timezone=' + timezone + '&graphTime=' + graphTime;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getSettingsAll(callback) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '';

        url = '/api/globals/getSettingsAll';

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getApis(callback, category, id = '', offset = '', column = '', token = '', offsetTz = '', timezone = '', graphTime = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        let url = '';
        if (id != '' && id != undefined)
            url = '/api/globals/servicestats?type=' + category + '&jid=' + id;
        else
            url = '/api/globals/servicestats?type=' + category + '&offset=' + offset + '&column=' + column + '&token=' + token + '&offset_tz=' + offsetTz + '&timezone=' + timezone+ '&graphTime=' + graphTime;

        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static getErrors(callback, category, offset = '', column = '', token = '', offsetTz = '', timezone = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = '/api/globals/getErrors?type='+ category + '&offset=' + offset + '&column=' + column + '&token=' + token + '&offset_tz=' + offsetTz + '&timezone=' + timezone;
        
        fetchJSON(url, options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }

    static runTheJobs(callback, jid, category) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/runjob?jobId=' + jid + '&type=' + category;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static markTheJobs(callback, jid, category) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/markjob?jobId=' + jid + '&type=' + category;
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static bulkMarkJobs(data, callback) {

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/bulkmarkjobs', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static retryAllJobs(data, callback) {
        let formData = new FormData();
        
        for (let key in data) {
            formData.append(key, data[key]);
        }
        
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        
        fetchJSON('/api/globals/retryAllJobs', options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    }

    static updateMember(slug, data, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members/' + slug, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static updateMemberHistory(slug, data, callback) {

        //MembersApi.callId++;
        // const callId = MembersApi.callId;

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/globals/updatehistory/' + slug, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });

    }

    static getRolesAndPermissions(callback){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/roles_permissions';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }

    static assignPermissions(role, data, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
            body: formData,
        };
        fetchJSON('/api/members/assignPermissions/' + role, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static assignPermissionToRole(role, permission, callback) {

        MembersApi.callId++;
        const callId = MembersApi.callId;

        const options = {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            },
            method: 'post',
        };
        fetchJSON('/api/members/setPermission/'+role+'/'+permission, options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getIoLogs(callback, page = 1, sbApi = '', sbToken = '',  sbTokenValue = '') {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        let url = '/api/globals/ioLogs?page=' + page;
        
        if (sbApi != '') {
            url += '&sbApi=' + sbApi;
        }

        if (sbToken != '') {
            url += '&sbToken=' + sbToken;
        }

        if (sbTokenValue != '') {
            url += '&sbTokenValue=' + sbTokenValue;
        }
        
        fetchJSON(url, options)
        .then((response) => {
            callback(response);
        })
        .catch((response) => {
            callback(response);
        });
    
    }

}
